import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    overlay: {
        ...StyleSheet.absoluteFill
    },
    hidden: {
        pointerEvents: "none",
        opacity: 0
    },
    plot: {
        position: "relative",
        width: "100%"
    },
    body: {
        width: "100%"
    },
    tableContent: {
        flexGrow: 1
    },
    table: {
        flex: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    plotHeight,
    isOverlaid
}: ChartContentDynamicStyleType) => {
    const styles = {
        plot: {} as Mutable<ViewStyle>
    };

    if(isOverlaid) {
        styles.plot.minHeight = plotHeight ?? shapeConfigs.chartHeight.medium;
    }

    return styles;
};
export default stylesheet;
